import React from 'react'

const RoundAlertIconWithWhiteBg = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5814_8035)">
        <path fillRule="evenodd" clipRule="evenodd" d="M24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5ZM12 11.5C12.5523 11.5 13 11.9477 13 12.5V16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5V12.5C11 11.9477 11.4477 11.5 12 11.5ZM12 7.5C11.4477 7.5 11 7.94772 11 8.5C11 9.05229 11.4477 9.5 12 9.5H12.01C12.5623 9.5 13.01 9.05229 13.01 8.5C13.01 7.94772 12.5623 7.5 12.01 7.5H12Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_5814_8035">
          <path d="M0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5Z" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  )
}

export default RoundAlertIconWithWhiteBg
